const BEAM = process.env.PUBLIC_URL + '/img/acero/steel-i-beam-on-transparent-background-showing-its-polished-surface-and-structural-features-ideal-for-industrial-and-construction-use-free-png.webp';

export default function Hero() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="inicio" className="hero">
      <div className="hero-yellow-bar" />
      <div className="hero-yellow-corner" />

      <div className="hero-inner">
        <div className="hero-content">
          <p className="hero-overline">Distribuidora de Materiales de Acero</p>
          <h1 className="hero-title">
            ACEROS
            <span className="hero-title-accent">JALOS</span>
          </h1>
          <p className="hero-subtitle">
            Calidad, resistencia y confianza en cada tonelada.
    
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => scrollTo('productos')}>
              Ver Productos
            </button>
            <button className="btn btn-outline" onClick={() => scrollTo('contacto')}>
              Contáctanos
            </button>
          </div>
        </div>

        <div className="hero-image-col">
          <img
            src={BEAM}
            alt="Viga de acero estructural"
            className="hero-beam"
          />
        </div>
      </div>

      <div className="hero-stats">
        <div className="hero-stats-inner">
          <div className="hero-stat">
            <span className="stat-number">+10</span>
            <span className="stat-label">Años de experiencia</span>
          </div>
          <div className="hero-stat">
            <span className="stat-number">+500</span>
            <span className="stat-label">Clientes satisfechos</span>
          </div>
          <div className="hero-stat">
            <span className="stat-number">10+</span>
            <span className="stat-label">Tipos de productos</span>
          </div>
        </div>
      </div>
    </section>
  );
}
